import styled from 'styled-components'

interface ITabsProperties {
    active: boolean
}

export const Tab = styled.button<ITabsProperties>`
    font-size: 16px;
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
    width: 50%;
    opacity: 0.6;
    border: 0;
    border-bottom: 2px solid ${properties => properties.theme.variables.lineBorder};
    background: ${properties => properties.theme.variables.colorBackground};
    outline: 0;
    ${({ active }) =>
        active &&
        `
    border: 0;
    border-bottom: 2px solid;
    width: 50%;
    opacity: 1;
  `}
`
export const ButtonGroup = styled.div`
    display: flex;
    width: 85%;
    margin: 4px auto;
    justify-content: space-between;
`
export const ConnectButton = styled.button`
    display: flex;
    align-items: center;
    background: ${properties => properties.theme.variables.colorText};
    color: ${properties => properties.theme.variables.colorBackground};
    box-sizing: border-box;
    width: 80%;
    cursor: pointer;
    margin-top: 12px;
    justify-content: center;
    height: 24px;
    border-radius: 27px;
    padding: 1rem 1.5rem;
    box-shadow: none;
    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-transform: capitalize;
`
export const FormsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const InputEmail = styled.input`
    width: 80%;
    padding: 8px;
`
